import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  content123: {
    minWidth: '610px',
  },
}));

export default useStyles;
